export var PhysicalStreamType;
(function (PhysicalStreamType) {
    PhysicalStreamType["PRESENT"] = "PRESENT";
    PhysicalStreamType["DATA"] = "DATA";
    PhysicalStreamType["OFFSET"] = "OFFSET";
    PhysicalStreamType["LENGTH"] = "LENGTH";
})(PhysicalStreamType || (PhysicalStreamType = {}));
//# sourceMappingURL=physicalStreamType.js.map